import moment from 'moment';
import Assignment from "./assignment";


 


        class Calllocation{
         constructor(params,o){
          this.id = o.id;
          this.accountType = "Calllocation";
          this._types = {
            "assignment":Assignment
          }
             this.generic = {
              name:"",
              id:"",
              platformId:"",
              customerId:"",
              loginCustomerId:false,
              description:"",
              subTitle:"",
              accountType:"Calllocation"
            }
               
            this.setParameters(o);
               

            for (var t of Object.keys(this._types)){
              if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
                for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
                  if (pt.objectIds.indexOf(this.id) > -1){
                    for (var oid of pt.pivotObjectIds){
                      if ((params.accounts[pt.pivotAccountId] && params.accounts[pt.pivotAccountId][oid]) && (!this.filter || (this.filter && this.filter[pt.pivotAccountId] && this.filter[pt.pivotAccountId].indexOf(oid) > -1))) {
                        params.accounts[pt.pivotAccountId][oid].filter = (this.filter) ? this.filter : false;
                        params.accounts[pt.pivotAccountId][oid].truncate = (this.truncate) ? this.truncate : false;
                        var acs = params.accounts[pt.pivotAccountId][oid];
                        acs.originId = pt.originId;
                        acs.originAccountId = pt.originAccountId;
                        
                    var model = new this._types[t](params,acs);
                      this.setModelParameters(model);
                      }
                    }
                  }
              }
            }
            }
           
   }



             setParameters(params){
               for (var prop in params){
                   if (params.hasOwnProperty(prop)){
                       var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                       if (this[method]){
                         this[method](params[prop]);
                       }
                       
                   }
               }

           }

           setTracking_number(val){
            this.tracking_number = val;
          }

           setSource(val){
            this.source = val;
            this.generic.subTitle = val;
            
           }

           setLabel(val){
            this.label = val;
            this.generic.label = val;
            this.generic.name = val;
            
           }
setAccount_id(a){
  this.account_id = a;
}
         setPlatformId(pid){
          this.platformId = pid;
          this.generic.platformId = pid;
         }
             
           setId(id){
               this.id = id;
               this.generic.id = id;
         }




         setOriginAccountId(id){
          this.originAccountId = id;
          this.generic.originAccountId = id;
        }
        setOriginId(id){
          this.originId = id;
          this.generic.originId = id;
        }
           
           
         setTruncate(obj){
          if (obj){
          this.truncate = obj;
          this.filtered = (obj && obj[this.accountType] && (obj[this.accountType].indexOf(this.id) > -1)) ? false : true;
          }
        }
           
       
         
       
        setModelParameters(params){
          this.filtered = false;
          if (params.accountType == "Assignment"){
              if (params.parentProperty){
                this.variables = (this.variables) ? this.variables : [];
                var vo = {value:params.parentValue,label:params.parentProperty,variables:(params.variables) ? params.variables : []};
this.variables.push(vo);
              }
          }else{
             this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
             this[params.accountType].push(params);
          }
         }
     }
export default Calllocation;
        